import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';
import { DataService } from 'src/app/facilityOperations/facOps-dashboard/data.service';
import { EmailAndSMSService } from 'src/app/services/operations/EmailAndSMS.service';
import { IReportResponse } from '../models/ReportsModel';
import { ToastrService } from 'ngx-toastr';
import { ReportsService } from 'src/app/services/operations/reports.service';
import { GeneralService } from 'src/app/services/general.service';
import * as bootstrap from 'bootstrap';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { CommonMethodService } from '../common-method.service';
import { EmailRelinkPopupComponent } from '../email-relink-popup/email-relink-popup.component';
import { LetterAndNoticesService } from 'src/app/services/letterAndNotices.service';
import { twoWayService } from 'src/app/services/operations/two-way-text.service';
import { ISendEmailOutput, ISendEmailOutputModel } from 'src/app/Shared/interface2';
import { StoreService } from 'src/app/services/stores.service';
import { Modal } from 'bootstrap';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
import { RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';
import { EUserFunctions } from 'src/app/Shared/enum';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ProspectService } from 'src/app/services/operations/prospects.service';

@Component({
    selector: 'app-emaillog-popup',
    templateUrl: './emaillog-popup.component.html',
    styleUrls: ['./emaillog-popup.component.scss'],
    standalone: false
})
export class EmaillogPopupComponent implements OnInit {
  @ViewChild('EmailDialog', { static: true }) EmailDialog: ModalDirective;
  @ViewChild('PrintEmailLog', { static: true }) PrintEmailLog: ModalDirective;
  @ViewChild('EmailLogSelected', { static: true }) EmailLogSelected: ModalDirective;
  @ViewChild('EmailModal', { static: true }) EmailModal: ModalDirective;
  @ViewChild('emailRelink', { static: false }) emailRelink: EmailRelinkPopupComponent;
  @ViewChild('defaultRTE', { static: false }) public rte!: RichTextEditorComponent;
  @ViewChild('gridEmailLog') gridEmailLog: GridComponent;
  ngAfterViewInit(): void {
    this.EmailModal.onHidden.subscribe(() => {
      this.showParentModals();
    });
  }
  modalConfig = {
  backdrop: 'static'
};
  dataEmailLogs: any;
  public loaderIcon: Promise<boolean>;
  public todaysdate = new Date();
  toDateEmailLog;
  tenantId: number;
  oldestLedgerDateEmailLog: Date;
  fromDateEmailLog: any;
  minFromDateEmailLog: any;
  minToDateEmailLog: any;
  listEmailLogs = [];
  datepipe: DatePipe = new DatePipe('en');
  lines: string;
  filterSettings: Object;
  modalRef: BsModalRef;
  emailBody: string;
  unitNo: string;
  selectedUnitNo: string;
  toEmailAddress: string;
  fromEmailAddress: string;
  emailDate: string;
  typeStatus: string;
  emailSubject: string;
  userName: string;
  currentSelectedEmailLogId: number = null;
  reportUrl;
  facilityId: number;
  filteredEmailLogs: any[] = [];
  selectedFilter: string = 'All';
  selectedGrouping: string = 'none';
  groupingMode: string = 'none';
  groupedEmailLogs: any[] = [];
  groupedEmailsTotalCount = 0;
  letterTemplatelist: any;
  unitlist: any;
  mailfullContent: ISendEmailOutputModel;
  rteValue: string;
  isReplyClicked = false;
  isForwardClicked = false;
  templateTTTypeID = 0;
  ccEmails: string = '';
  bccEmails: string = '';
  isSendDisabled: boolean = true;
  selectedFiles: File[] = [];
  showEditor = false;
  relinkCompleted = false;
  showRelinkPopup = false;
  viewRightAdHocEmail = false;
  createRightAdHocEmail = false;
  createRightFalseMessage: string;
  tenantUnitlist: any[] = [];
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };


  constructor(
    private customerData: CustomerDataService,
    private emailAndSMSService: EmailAndSMSService,
    private modalService: BsModalService,
    public data: DataService,
    private reportService: ReportsService,
    private toastr: ToastrService,
    public generalService: GeneralService,
    private facOpsDataService: FacOpsDataService,
    private userSessionService: UserSessionService,
    private letterAndNoticesService: LetterAndNoticesService,
    private twoWayService: twoWayService,
    private storeService: StoreService,
    private translate: TranslateService,
    private modalWrapper: ModalWrapperService,
    private prospectsService: ProspectService,

  ) { }

  ngOnInit(): void {
    this.setUserPermissions();
    this.loaderIcon = Promise.resolve(true);
    this.lines = 'Both',
    this.filterSettings = { mode: 'Immediate', immediatemodedelay: 100 };
    this.modalWrapper.openDirective(this.EmailDialog);
    this.toDateEmailLog = new Date();
    this.dataEmailLogs =this.customerData?.CustomerInfoList? this.customerData.CustomerInfoList : null;
    this.getReportUrl()
    if (this.dataEmailLogs == null) {
      const contactInfo = this.facOpsDataService?.contactInfo?? '';
      const obj = {
        TenantName: `${contactInfo.FirstName ?? ''} ${contactInfo.MiddleName ?? ''} ${contactInfo.LastName ?? ''}`,
        Phone: contactInfo.BusinessAccount ? (contactInfo.CompanyPhone ? contactInfo.CompanyPhone : '') : (contactInfo.CellPhoneNumber ? contactInfo.CellPhoneNumber : ''),
        EmailID: contactInfo.BusinessAccount ? (contactInfo.CompanyEmail ? contactInfo.CompanyEmail : '') : (contactInfo.Email ? contactInfo.Email : ''),
        Address: contactInfo.BusinessAccount ? (contactInfo.CompanyAddress ? contactInfo.CompanyAddress : '') : (contactInfo.Address ? contactInfo.Address : ''),
        City: contactInfo.BusinessAccount ? (contactInfo.CompanyCity ? contactInfo.CompanyCity : '') : (contactInfo.City ? contactInfo.City : ''),
        TenantId: contactInfo.TenantId ?? '',
        CountryCode: contactInfo.BusinessAccount ? (contactInfo.CompanyDialInCode ?? '') : (contactInfo.DialInCode ?? ''),
        Zip: contactInfo.Zip ?? '',
        StateCode: contactInfo.State?.Code ?? '',
      };
      this.dataEmailLogs = obj;
    }
    this.filteredEmailLogs = [...this.listEmailLogs];
    this.facilityId = this.userSessionService.userSessionData.LastAccessedStoreId?? this.data.custimerInfoStorage.facilityID;
    this.tenantId = this.dataEmailLogs.TenantId;
    const modalElement = document.getElementById('EmailDialog');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
      this.loaderIcon = Promise.resolve(true);
    }
    if (this.tenantId) {
      this.getAllUnits(this.tenantId);
      this.getEmaillogs(this.tenantId);
    }else{
      this.listEmailLogs = [];
      this.loaderIcon = Promise.resolve(false);
    }
  }

  getEmaillogs(tenantId: number) {
    this.emailAndSMSService.getEmailLogsList(tenantId).subscribe((response: any[]) => {
      this.loaderIcon = Promise.resolve(false);
      if (response) {
        if (!response || response.length === 0) {
          this.oldestLedgerDateEmailLog = new Date();
        } else if (response.length && response.length > 1) {
          const oldestDateObject = response.reduce((a, b) => (a.EmailDate < b.EmailDate ? a : b));
          this.oldestLedgerDateEmailLog = oldestDateObject.EmailDate;
        } else {
          this.oldestLedgerDateEmailLog = response[0].EmailDate;
        }
        this.fromDateEmailLog = this.minFromDateEmailLog = this.minToDateEmailLog = JSON.parse(JSON.stringify(this.oldestLedgerDateEmailLog));
        this.fromDateEmailLog = this.fromDateEmailLog.replace('Z', '');
      }
      this.listEmailLogs = response
      .map(x => {
        x.EmailDate = x.EmailDate?.replace('Z', '');
        x.EmailDate = this.datepipe.transform(x.EmailDate, 'MM/dd/yyyy h:mm:ss a');
        return x;
      });
      this.filteredEmailLogs = [...this.listEmailLogs];
      if (this.groupingMode === 'branches') {
        const source = (this.filteredEmailLogs && this.filteredEmailLogs.length) ? this.filteredEmailLogs : this.listEmailLogs;
        const groups = source.reduce((acc, item) => {
          const subject = this.stripSubjectPrefix(item.Description) || 'No Subject';
          if (!acc[subject]) { acc[subject] = []; }
          acc[subject].push(item);
          return acc;
        }, {} as { [key: string]: any[] });
        this.groupedEmailLogs = Object.keys(groups).map(k => ({ subject: k, count: groups[k].length, items: groups[k], expanded: false }));
        this.filteredEmailLogs = this.groupedEmailLogs.map(g => ({ Description: g.subject, TotalMessages: g.count }));
      }
    }, (err: any) => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  refreshEmailStatus(data: any, event: MouseEvent) {
    event.stopPropagation();
    this.emailAndSMSService.refreshEmailStatus(data.Id).subscribe({
      next: (status: string) => {
        if (status && status.trim() !== '') {
          data.Status = status;
        }
      },
      error: (err: any) => {
        this.toastr.error('Failed to refresh email status', 'Failure', this.toasterConfig);
      }
    });
  }

  dataBound(grid) {
    Object.assign((<any>grid.filterModule).filterOperators, { startsWith: 'contains' });
  }

  rowSelectedEmailLogs(event) {
    const modalElement = document.getElementById('EmailLogSelected');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
    this.emailBody = event.data.EmailBody;
    this.unitNo = event.data.UnitNo;
    this.toEmailAddress = event.data.ToEmailAddress;
    this.fromEmailAddress = event.data.FromEmailAddress;
    this.emailDate = event.data.EmailDate;
    this.typeStatus = event.data.Type;
    this.emailSubject = event.data.Description;
    this.userName = event.data.UserName;
    this.currentSelectedEmailLogId = event.data.Id;

    // FR-12 — Mark as read on open if not already read
    if (!event.data.IsRead && event.data.Id) {
      this.emailAndSMSService.markEmailAsRead({ EmailLogId: event.data.Id, FacilityId: this.facilityId }).subscribe({
        next: () => {
          event.data.IsRead = true;
          // Reflect in both list arrays so the unread indicator clears
          [this.listEmailLogs, this.filteredEmailLogs].forEach(list => {
            const item = list.find(x => x.Id === event.data.Id);
            if (item) { item.IsRead = true; }
          });
        }
      });
    }
  }

  onCancel(){
    this.EmailDialog.hide();
    this.data.emailLogsPopup = false;
  }

  changeEmailLogFromDate(value) {
    this.minToDateEmailLog = value;
    if ((this.toDateEmailLog !== '') && (this.toDateEmailLog != null)) {
      if (value.getTime() > this.toDateEmailLog.getTime()) {
        this.toDateEmailLog = null;
      }
    }
  }

  emailLogPrint() {
    this.toDateEmailLog = this.datepipe.transform(new Date(this.toDateEmailLog), 'MM/dd/yyyy');
    this.fromDateEmailLog = this.datepipe.transform(new Date(this.fromDateEmailLog), 'MM/dd/yyyy');
    this.loaderIcon = Promise.resolve(true);
    const reportParameters = {
      ToDate: this.toDateEmailLog,
      FromDate: this.fromDateEmailLog,
      TenantId: this.tenantId
    };

    const inputModel = {
      ReportName: 'EmailLog',
      ReportParameters: reportParameters,
      SortBy: 1,
      StorageFacilities: [
        this.facilityId
      ]
    };

    const openInNewTab = '_blank';
    this.reportService.generateReport(inputModel).subscribe((response: IReportResponse) => {
      if (response.Success) {
        window.open(this.reportUrl + `report?id=` + response.ReportRequestId,
          openInNewTab, 'width=' + (screen.availWidth - 5) + ',height=' + (screen.availHeight - 5));
        this.loaderIcon = Promise.resolve(false);
      } else {
        this.toastr.error('Ledger generation Failed', 'Failure', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    }, (err: any) => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  getReportUrl() {
    this.generalService.getReportUrl().subscribe((response: any) => {
      this.reportUrl = response;
    }, (err: any) => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  disablePrintEmailLog() {
    if ((this.toDateEmailLog === '' || this.toDateEmailLog === null) || (this.fromDateEmailLog === '' || this.fromDateEmailLog === null)) {
      return true;
    } else {
      return false;
    }
  }

  openPrintEmailLog() {
    const modalElement = document.getElementById('PrintEmailLog');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  filterEmails(type: string): void {
    this.selectedFilter = type;

    if (type === 'All') {
      this.filteredEmailLogs = [...this.listEmailLogs];
    }
    else if (type === 'Inbound' || type === 'Outbound') {
      this.filteredEmailLogs = this.listEmailLogs.filter(x => x.Type?.toLowerCase() === type.toLowerCase());
    } else if (type === 'Failed') {
      this.filteredEmailLogs = this.listEmailLogs.filter(x => x.Status?.toLowerCase() === type.toLowerCase());
    } else if (type === 'Delivered') {
      this.filteredEmailLogs = this.listEmailLogs.filter(x => x.Status?.toLowerCase() !== 'failed');
    }
    // if grouping is enabled, rebuild grouped view from current filtered set
    if (this.groupingMode === 'branches') {
      const source = (this.filteredEmailLogs && this.filteredEmailLogs.length) ? this.filteredEmailLogs : null;
      if (source && source.length) {
        const groups = source.reduce((acc, item) => {
          const subject = this.stripSubjectPrefix(item.Description) || 'No Subject';
          if (!acc[subject]) { acc[subject] = []; }
          acc[subject].push(item);
          return acc;
        }, {} as { [key: string]: any[] });
        this.groupedEmailLogs = Object.keys(groups).map(k => ({ subject: k, count: groups[k].length, items: groups[k], expanded: false }));
        this.filteredEmailLogs = this.groupedEmailLogs.map(g => ({ Description: g.subject, TotalMessages: g.count }));
        this.groupedEmailsTotalCount = this.groupedEmailLogs.reduce((total, group) => total + group.count, 0);
      } else {
        this.groupedEmailLogs = null;
        this.filteredEmailLogs = null;
        this.groupedEmailsTotalCount = 0;
      }
    }
    setTimeout(() => {
      if (this.gridEmailLog) {
        this.gridEmailLog.dataSource = [...this.filteredEmailLogs];
        this.gridEmailLog.refreshColumns();
      }
    }, 100);
  }

  setGrouping(mode: string) {
    this.selectedGrouping = mode;
    this.groupingMode = mode;

    if (mode === 'branches') {
      const source = (this.filteredEmailLogs && this.filteredEmailLogs.length) ? this.filteredEmailLogs : this.listEmailLogs;
    const groups = source.reduce((acc, item) => {
      const subject = this.stripSubjectPrefix(item.Description) || 'No Subject';
      if (!acc[subject]) { acc[subject] = []; }
      acc[subject].push(item);
      return acc;
    }, {} as { [key: string]: any[] });

      this.groupedEmailLogs = Object.keys(groups).map(k => ({ subject: k, count: groups[k].length, items: groups[k], expanded: false }));
      this.groupedEmailsTotalCount = this.groupedEmailLogs.reduce((total, group) => total + group.count, 0);
      this.filteredEmailLogs = this.groupedEmailLogs.map(g => ({ Description: g.subject, TotalMessages: g.count }));
    } else {
      this.groupedEmailLogs = [];
      this.filteredEmailLogs = [...this.listEmailLogs];
    }
    this.filterEmails(this.selectedFilter);
  }

  toggleGroup(index: number): void {
    if (this.groupedEmailLogs && this.groupedEmailLogs[index]) {
      this.groupedEmailLogs[index].expanded = !this.groupedEmailLogs[index].expanded;
    }
  }

  ReplyEmail() {
    this.hideParentModals();
    this.isSendDisabled = false;
    this.isReplyClicked = true;
    this.isForwardClicked = false;
    this.templateTTTypeID = 0;
    // FR-18 — pre-fill recipient and subject
    this.toEmailAddress = this.toEmailAddress;
    this.ccEmails = '';
    this.bccEmails = '';
    const bare = this.stripSubjectPrefix(this.emailSubject);
    this.emailSubject = `Re: ${bare}`;
    this.rteValue = this.buildQuotedBody();
    this.getLettersAndNoticesTemplateList();
    this.updateUnitList();
    this.selectedUnitNo = this.unitNo;
    this.showEditor = true;
    this.EmailModal.show();
    this.checkSendButtonState();
  }

  ForwardEmail() {
    this.hideParentModals();
    this.isSendDisabled = false;
    this.isForwardClicked = true;
    this.isReplyClicked = false;
    this.templateTTTypeID = 0;
    // FR-19 — pre-fill subject with Fwd: prefix
    this.toEmailAddress = '';
    this.ccEmails;
    this.bccEmails = '';
    const bare = this.stripSubjectPrefix(this.emailSubject);
    this.emailSubject = `Fwd: ${bare}`;
    this.rteValue = this.buildQuotedBody();
    this.getLettersAndNoticesTemplateList();
    this.updateUnitList();
    this.selectedUnitNo = this.unitNo;
    this.showEditor = true;
    this.EmailModal.show();
    this.checkSendButtonState();
  }

  openComposeEmail() {
    this.isReplyClicked = false;
    this.isForwardClicked = false;
    this.templateTTTypeID = 0;
    this.unitNo = this.dataEmailLogs.UnitNo;
    this.toEmailAddress = this.dataEmailLogs.EmailID;
    this.emailSubject = '';
    this.rteValue = '';
    this.ccEmails = '';
    this.bccEmails = '';
    this.isSendDisabled = true;
    this.getLettersAndNoticesTemplateList();
    this.updateUnitList();
    this.selectedUnitNo = this.unitlist?.[0]?.UnitNo ?? '';
    this.showEditor = true;
    this.EmailModal.show();
    this.checkSendButtonState();
  }

  onUnitChange(event: Event): void {
    this.selectedUnitNo = (event.target as HTMLSelectElement).value;
    this.dataEmailLogs.UnitNo = this.selectedUnitNo;
    this.templateTTTypeID = 0;
    this.getLettersAndNoticesTemplateList();
  }

  checkSendButtonState(emailBody?: string) {
    const body = emailBody !== undefined
      ? emailBody
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .trim()
      : (this.rte
        ? this.rte.getText()?.trim()
        : (this.rteValue || '')
          .replace(/<[^>]*>/g, '')
          .replace(/&nbsp;/g, ' ')
          .trim());

    this.isSendDisabled =
      !this.toEmailAddress?.trim() ||
      !this.emailSubject?.trim() ||
      !body;
  }

  markAllAsRead() {
    if (!this.facilityId) { return; }
    this.emailAndSMSService.markAllEmailsAsRead({ FacilityId: this.facilityId }).subscribe({
      next: () => {
        [this.listEmailLogs, this.filteredEmailLogs].forEach(list =>
          list.forEach(item => { item.IsRead = true; })
        );
      }
    });
  }

  private stripSubjectPrefix(subject: string): string {
    if (!subject) { return ''; }
    return subject.replace(/^(Re|Fwd|Fw):\s*/i, '').trim();
  }

  private buildQuotedBody(): string {
    const original = this.emailBody || '';
    return `<br><br>--- Original Message ---<br>${original}`;
  }

  getLettersAndNoticesTemplateList() {
    this.loaderIcon = Promise.resolve(true);
    this.letterAndNoticesService.GetLettersAndNoticesTemplateListByTypeIdAndFacilityId(201, this.facilityId).subscribe((response: any) => {
      this.letterTemplatelist = response;
      this.loaderIcon = Promise.resolve(false);
    });
  }

  onTemplateChange(event) {
    var templateID = parseInt(event);
    if (templateID) {
      this.getEmailBody(templateID);
    }
  }

  openRelinkPopup(email: any): void {
    // GAP-15 — use email.Id directly; no redundant list fetch needed
    this.relinkCompleted = false;
    this.showRelinkPopup = true;
    const emailLogModal = bootstrap.Modal.getInstance(document.getElementById('EmailLogSelected'));
    this.EmailDialog.hide();
    emailLogModal?.hide();
    this.loaderIcon = Promise.resolve(true);

    this.storeService.getStores().subscribe({
      next: (stores) => {
        this.loaderIcon = Promise.resolve(false);

        const modalRef: BsModalRef = this.modalWrapper.openComponent(
          EmailRelinkPopupComponent,
          {
            initialState: {
              emailData: {
                EmailId: email.Id,   // GAP-15 — field name matches proceedRelink()
                parentModal: null
              },
              allStores: stores
            },
            class: 'modal-dialog-centered modal-xl',
            backdrop: 'static',
            keyboard: false
          }
        );

        modalRef.content.onRelinkSuccess.subscribe((result) => {
          this.relinkCompleted = true;
          this.showRelinkPopup = false;
          if (result?.success) {
            this.toastr.success('Relink email was successful', 'Success', this.toasterConfig);
            this.loaderIcon = Promise.resolve(true);
            this.EmailDialog.show();
            emailLogModal?.hide();
            if (this.tenantId) {
              this.getEmaillogs(this.tenantId);
            }
          } else {
            this.toastr.error('Failed to relink email', 'Failure', this.toasterConfig);
            this.EmailDialog.show();
            emailLogModal?.show();
          }
        });
        modalRef.onHidden?.subscribe(() => {
          if (!this.relinkCompleted) {
            this.showRelinkPopup = false;
            this.EmailDialog.show();
            emailLogModal?.show();
          }
        });
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
        this.showRelinkPopup = false;
        this.EmailDialog.show();
        emailLogModal?.show();
      }
    });
  }


  onRelinkConfirmed(event: any) {
    // refresh list or handle success
    this.toastr.success('Relink completed', 'Success', this.toasterConfig);
    // reload email logs if needed
    if (this.tenantId) { this.getEmaillogs(this.tenantId); }
  }
  getEmailBody(id) {
    const selectedUnit = this.unitlist.find(x => x.UnitNo === this.selectedUnitNo && x.FacilityId === this.facilityId);
    let obj = {
      InquiryNo: selectedUnit?.InquiryNo ?? null,
      ReservationNo: selectedUnit?.ReservationNo ?? null,
      LeaseNo: selectedUnit?.LeaseNo ?? null,
      FacilityId: this.facilityId,
      ToEmailAddress: '',
      FromEmailAddress: '',
      CCEmailAddress: '',
      BCCEmailAddress: '',
      CCToStoreEmailAddress: '',
      TransactionTypeId: 0,
      InvoiceNumber: 0,
      ReceiptNumber: 0,
      TenantLettersAndNoticesIds: [],
      TenantAlternateLettersAndNoticesIds: [],
      SendToAlternate: true,
      IpAddress: '',
      DripcampaignActionId: 0,
      DripcampaignLetterId: id,
      SelectedTemplateId: id
    }
    this.loaderIcon = Promise.resolve(true);
    this.twoWayService.getBody(obj).subscribe((response: ISendEmailOutputModel) => {
      if (response?.EmailModel?.EmailBody && response?.EmailModel?.Subject) {
        this.mailfullContent = response;
        this.rteValue = this.mailfullContent.EmailModel.EmailBody;
        this.emailSubject = this.mailfullContent.EmailModel.Subject;
        this.checkSendButtonState(response.EmailModel.EmailBody);
      } else {
        this.mailfullContent = null;
        this.rteValue = '';
        this.emailSubject = '';
        this.checkSendButtonState();
      }
      this.loaderIcon = Promise.resolve(false);
    });
  }

  async sendEmail() {
    const attachments = this.selectedFiles.length
      ? await Promise.all(
        this.selectedFiles.map(file => this.fileToAttachment(file))
      )
      : [];
    let emailList = [];
    let emodel = {
      Subject: this.emailSubject,
      EmailBody: this.rteValue,
      FromAddress: this.fromEmailAddress,
      ToAddress: this.toEmailAddress,
      CcAddress: this.ccEmails,
      BccAddress: this.bccEmails,
      ToList: this.generateEmailAddressList(this.toEmailAddress),
      CcList: this.generateEmailAddressList(this.ccEmails),
      BccList: this.generateEmailAddressList(this.bccEmails),
      Files: attachments
    };
    const selectedUnit = this.unitlist.find(x => x.UnitNo === this.selectedUnitNo && x.FacilityId === this.facilityId);
    let emailbody = {
      EmailIdentifier: 1,
      EmailModel: emodel,
      LeaseNo: selectedUnit?.LeaseNo ?? null,
      FacilityId: this.facilityId,
      ReservationNumber: selectedUnit?.ReservationNo ?? null,
      InquiryNumber: selectedUnit?.InquiryNo ?? null,
      FollowUpId: null,
      DripCampaignActionId: null,
      Description: this.emailSubject,
      Type: 0,
      TypeReferenceId: 0,
      SendtoAlternate: true,
      TransactionTypeId: 46,
      Ip: '',
      SentTo: 386,
      SentRegisteredEmail: this.mailfullContent?.SentRegisteredEmail ?? false,
      SelectedTemplateId: this.templateTTTypeID,
      TenantID: this.tenantId,
    };
    emailList.push(emailbody);
    if (this.toEmailAddress) {
      this.twoWayService.sendEmail(emailList).subscribe((response: ISendEmailOutput[]) => {
        if (response && response.length > 0 && response[0].Success) {
          this.toastr.success('Email Sent Successfully', 'Success', this.toasterConfig);
          if (this.tenantId) {
            this.getEmaillogs(this.tenantId);
          }
        } else {
          this.toastr.error('Failed to send email', 'Failure', this.toasterConfig);
        }
      });
    } else {
      this.toastr.error('No email address Added', 'Failure', this.toasterConfig);
    }
    this.templateTTTypeID = 0;
    this.EmailModal.hide();
    this.showEditor = false;
  }

  private generateEmailAddressList(emails: string): { Email: string; Name: string }[] {
    return emails
      ? (emails
        .split(/[,;]/)
        .map(x => x.trim())
        .filter(x => x)
        .map(email => ({
          Email: email,
          Name: ''
        })))
      : [];
  }

  private hideParentModals(): void {
    const emailLogModal = bootstrap.Modal.getInstance(
      document.getElementById('EmailLogSelected')
    );

    this.EmailDialog.hide();
    emailLogModal?.hide();
  }

  private showParentModals(): void {
    this.EmailDialog.show();

    const emailLogModal = bootstrap.Modal.getInstance(
      document.getElementById('EmailLogSelected')
    );

    emailLogModal?.show();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files) {
      this.selectedFiles = Array.from(input.files);

    }
  }

  private async convertFileToBase64(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve({
          FileName: file.name,
          ContentType: file.type,
          FileContent: (reader.result as string).split(',')[1] // remove data prefix
        });
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  }

  private fileToAttachment(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const base64 = (reader.result as string).split(',')[1];

        resolve({
          AttachmentFile: base64,
          AttachmentFileName: file.name,
          FileType: file.type
        });
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  }

  getAllUnits(tenantId: number) {
    this.prospectsService.getAllUnits(tenantId).subscribe(
      (response: any[]) => {
        if (response) {
          this.tenantUnitlist = response;
          if (this.showEditor) {
            this.updateUnitList();
          }
        }
      }
    );
  }

  private updateUnitList() {
    const uniqueUnits = new Map<string, any>();
    (this.tenantUnitlist || []).forEach(x => {
      const key = `${x.FacilityName}|${x.UnitNumber}`;
      if (!uniqueUnits.has(key)) {
        uniqueUnits.set(key, {
          FacilityName: x.FacilityName,
          UnitNo: x.UnitNumber,
          LeaseNo: x.LeaseNo,
          FacilityId: x.FacilityId,
          ReservationNo: x.ReservationNo,
          InquiryNo: x.InquiryNo
        });
      }
    });
    this.unitlist = Array.from(uniqueUnits.values());
  }

  setUserPermissions() {
    this.createRightFalseMessage = this.generalService.CreateRightFalseMessage;
    let userPermissionAdHocEmail = this.generalService.getUserPermissionsForModule(EUserFunctions.DashboardEmailOption);
    this.viewRightAdHocEmail = userPermissionAdHocEmail.ViewRight;
    this.createRightAdHocEmail = userPermissionAdHocEmail.CreateRight;
  }
}
